import { Checkbox, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { Company } from '../../../models/company-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';

interface DemoCompanyProps {
  companyDetails: Company | undefined;
  canUpdate: boolean;
}

export default function DemoCompany({ companyDetails, canUpdate = false }: DemoCompanyProps) {
  const demoMutation = CustomerServiceQueries.useToggleDemo(
    companyDetails?.id ?? 0
  );
  const [isChecked, setIsChecked] = useState(companyDetails?.isDemoCompany);

  useEffect(() => {
    setIsChecked(companyDetails?.isDemoCompany);
  }, [companyDetails]);

  const handleToggleDemo = async (isChecked: boolean) => {
    setIsChecked(isChecked);
    await demoMutation.mutateAsync(isChecked);
  };

  if (!companyDetails || !canUpdate) return null;

  return (
    <Spin spinning={demoMutation.isLoading}>
      <Row style={{ marginTop: 16 }}>
        <Checkbox
          checked={isChecked}
          onChange={(e) => handleToggleDemo(e.target.checked)}
        >
          Is Demo Company
        </Checkbox>
      </Row>
      <Row style={{ paddingLeft: 24 }}>
        <small>Flags company as internal use only and not a customer</small>
      </Row>
    </Spin>
  );
}
